import { createSlice } from "@reduxjs/toolkit";
import { createStamp, fetchStamps, updateStamp, deleteStamp } from "./stamps.action";

const initialState = {
    stampData: [],
    loading: false,
    error: null,
};

const stampSlice = createSlice({
    name: "signatures",
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(createStamp.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createStamp.fulfilled, (state) => {
                state.loading = false;
                state.error = null;
            })
            .addCase(createStamp.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || true;
            })


            .addCase(fetchStamps.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchStamps.fulfilled, (state, action) => {
                state.loading = false;
                state.stampData = action?.payload;
                state.error = null;
            })
            .addCase(fetchStamps.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || true;
            })

            .addCase(updateStamp.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateStamp.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
            })
            .addCase(updateStamp.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || true;
            })

            .addCase(deleteStamp.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteStamp.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
            })
            .addCase(deleteStamp.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || true;
            })
    },
});

export default stampSlice.reducer;
